export const siteConfig = {
  siteTitle: 'Convex SaaS',
  siteDescription:
    'A Lightweight, Production-Ready Convex Stack for your next SaaS Application.',
  siteUrl: 'https://convex.dev',
  siteImage: '/images/og-image.png',
  favicon: '/favicon.ico',
  twitterHandle: '',
  email: '',
  address: '',
} as const
